import { Route, Routes } from "react-router-dom";
import SharedView from "../views/SharedView";
import JobAcceptView from "../views/JobAcceptView";
import JobCloseView from "../views/JobCloseView";
import InvoiceView from "../views/InvoiceView";
import ReportView from "../views/ReportView";
import PaymentRegisterThankYou from "../views/PaymentRegisterThankYou";
import InvoiceTapToPay from "../views/InvoiceTapToPay";
import OfferView from "../views/OfferView";

function PublicRoutes() {

    return (
        <Routes>
            <Route key={1} path="/share/acceptjobbytech/:token" element={<JobAcceptView />} />
            <Route key={2} path="/share/closejobbytech/:token" element={<JobCloseView />} />
            <Route key={3} path="/share/invoice/:owner/:id/:token" element={<InvoiceView />} />
            <Route key={7} path="/share/report/:owner/:id/:token" element={<ReportView />} />
            <Route key={4} path="/share/:selectedId" element={<SharedView />} />
            <Route key={5} path="/public/payment/registration-thankyou" element={<PaymentRegisterThankYou />} />

            <Route key={6} path="/public/flat/invoice/taptopay/:owner/:id/:token" element={<InvoiceTapToPay />} />
            <Route key={8} path="/public/offer/:token" element={<OfferView />} />


        </Routes>
    );
}

export default PublicRoutes;